import { ApiClient } from '../../http/api_client';

export class ItemRefineSearchRepository {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  async getItemRefineSearchHtml(url: string) {
    return await ApiClient.get(url, {
      responseType: "document",
      timeout: 30_000 // 検索画面ではデフォルトの3sではなく、30sにする
    });
  }
}
